import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, withKeys as _withKeys, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue";
const _hoisted_1 = {
  class: "list-page-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "page-toolbar"
};
const _hoisted_3 = {
  class: "toolbar-items"
};
const _hoisted_4 = {
  class: "toolbar-buttons"
};
const _hoisted_5 = {
  key: 1,
  class: "search-bar-wrapper"
};
const _hoisted_6 = {
  class: "search-bar"
};
const _hoisted_7 = {
  class: "search-bar-extra"
};
const _hoisted_8 = {
  class: "page-body"
};
const _hoisted_9 = {
  class: "left-panel"
};
const _hoisted_10 = {
  class: "right-panel"
};
import { computed, reactive, watch, ref, provide } from 'vue';
import { MgSearchBar } from '../mg-search-bar';
import { MgToolbar } from '../mg-toolbar';
import { MgQueryFilterDropdown } from '../mg-query-filter';
export default {
  __name: 'mg-list-page-layout',
  props: {
    showSearchbar: {
      type: Boolean,
      default: true
    },
    showToolbar: {
      type: Boolean,
      default: true
    },
    showLeftPanel: {
      type: Boolean,
      default: false
    },
    showRightPanel: {
      type: Boolean,
      default: false
    },
    filterFields: {
      type: [Array, Object],
      default: () => []
    },
    searchFields: {
      type: Array,
      default: () => []
    },
    toolbar: {
      type: Array,
      default: () => []
    },
    leftPanel: {
      type: Object,
      default: () => ({
        width: '200px',
        showAction: true
      })
    },
    rightPanel: {
      type: Object,
      default: () => ({
        width: '200px',
        showAction: true
      })
    }
  },
  emits: ['search', 'resetSearch', 'applyFilter', 'resetFilter', 'cancelFilter', 'toolbarItemClick', 'toolbarItemDropdownClick'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const emit = __emit;
    const searchBarRef = ref();
    const props = __props;
    const searchBarCollapse = ref(true);
    const showFilterButton = computed(() => {
      if (!props.filterFields) return false;
      if (Array.isArray(props.filterFields)) {
        return props.filterFields.length > 0;
      } else if (typeof props.filterFields === 'object' && Array.isArray(props.filterFields.items)) {
        return props.filterFields.items.length > 0;
      }
      return false;
    });
    const leftSplitPanelProps = reactive({
      width: '100%',
      height: '100%',
      panelWidth: '200px',
      border: false,
      padding: false,
      actionConfig: {
        enabled: true,
        showPrevButton: true
      }
    });
    const rightSplitPanelProps = reactive({
      width: '100%',
      height: '100%',
      panelWidth: '200px',
      border: false,
      padding: false,
      actionConfig: {
        enabled: true,
        showNextButton: true
      }
    });
    const searchbarEvents = {
      search(params) {
        emit('search', params);
      },
      resetSearch() {
        emit('resetSearch');
      }
    };
    const filterDropdownEvents = {
      cancelFilter() {
        emit('cancelFilter');
      },
      applyFilter(data) {
        emit('applyFilter', data);
      },
      'resetFilter'(data) {
        emit('resetFilter', data);
      }
    };
    const handleSearchClickEvent = () => {
      !!searchBarRef.value && searchBarRef.value.submit();
    };
    const handleToolbarItemClick = ({
      item,
      $event
    }) => {
      emit('toolbarItemClick', {
        item,
        $event
      });
    };
    const handleToolbarItemDropdownClick = ({
      item,
      option,
      $event
    }) => {
      emit('toolbarItemDropdownClick', {
        item,
        option,
        $event
      });
    };
    watch(() => props.leftPanel, val => {
      const {
        width = '200px',
        showAction = false
      } = val || {};
      leftSplitPanelProps.actionConfig.enabled = showAction;
      leftSplitPanelProps.panelWidth = width;
    }, {
      immediate: true,
      deep: true
    });
    watch(() => props.rightPanel, val => {
      const {
        width = '200px',
        showAction = false
      } = val || {};
      rightSplitPanelProps.actionConfig.enabled = showAction;
      rightSplitPanelProps.panelWidth = width;
    }, {
      immediate: true,
      deep: true
    });
    const publicMethods = {
      'doSearch'() {
        handleSearchClickEvent();
      }
    };
    __expose(publicMethods);
    provide('$list-page-layout', Object.assign({}, publicMethods, {
      isSupported: () => true
    }));
    return (_ctx, _cache) => {
      const _component_vxe_button = _resolveComponent("vxe-button");
      const _component_vxe_split_pane = _resolveComponent("vxe-split-pane");
      const _component_vxe_split = _resolveComponent("vxe-split");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [__props.showToolbar ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_renderSlot(_ctx.$slots, "toolbar-items", {}, () => [_createVNode(_unref(MgToolbar), {
        items: __props.toolbar,
        onItemClick: handleToolbarItemClick,
        onItemDropdownClick: handleToolbarItemDropdownClick
      }, null, 8, ["items"])])]), _createElementVNode("div", _hoisted_4, [_renderSlot(_ctx.$slots, "toolbar-buttons")])])) : _createCommentVNode("", true), __props.showSearchbar ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_renderSlot(_ctx.$slots, "search-bar", {}, () => [_createVNode(_unref(MgSearchBar), _mergeProps({
        ref_key: "searchBarRef",
        ref: searchBarRef,
        "show-buttons": false,
        collapse: searchBarCollapse.value,
        "onUpdate:collapse": _cache[0] || (_cache[0] = $event => searchBarCollapse.value = $event),
        items: __props.searchFields
      }, _toHandlers(searchbarEvents)), null, 16, ["collapse", "items"])])]), _createElementVNode("div", _hoisted_7, [!!__props.searchFields && __props.searchFields.length > 1 ? (_openBlock(), _createBlock(_component_vxe_button, {
        key: 0,
        onClick: _cache[1] || (_cache[1] = $event => searchBarCollapse.value = !searchBarCollapse.value)
      }, {
        default: _withCtx(() => [_cache[2] || (_cache[2] = _createElementVNode("span", null, "更多", -1)), _createElementVNode("i", {
          class: _normalizeClass({
            'vxe-icon-arrow-down': searchBarCollapse.value,
            'vxe-icon-arrow-up': !searchBarCollapse.value
          })
        }, null, 2)]),
        _: 1
      })) : _createCommentVNode("", true), _createVNode(_component_vxe_button, {
        icon: "vxe-icon-search",
        status: "success",
        onClick: handleSearchClickEvent,
        onKeydown: _withKeys(handleSearchClickEvent, ["enter"])
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("搜索", -1)]))]),
        _: 1
      }), _renderSlot(_ctx.$slots, "search-bar-extra", {}, () => [showFilterButton.value ? (_openBlock(), _createBlock(_unref(MgQueryFilterDropdown), _mergeProps({
        key: 0,
        items: __props.filterFields
      }, _toHandlers(filterDropdownEvents)), null, 16, ["items"])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_8, [_createVNode(_component_vxe_split, _normalizeProps(_guardReactiveProps(leftSplitPanelProps)), {
        default: _withCtx(() => [__props.showLeftPanel ? (_openBlock(), _createBlock(_component_vxe_split_pane, {
          key: 0,
          width: leftSplitPanelProps.panelWidth
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_renderSlot(_ctx.$slots, "left-panel")])]),
          _: 3
        }, 8, ["width"])) : _createCommentVNode("", true), _createVNode(_component_vxe_split_pane, null, {
          default: _withCtx(() => [_createVNode(_component_vxe_split, _normalizeProps(_guardReactiveProps(rightSplitPanelProps)), {
            default: _withCtx(() => [_createVNode(_component_vxe_split_pane, null, {
              default: _withCtx(() => [_renderSlot(_ctx.$slots, "default")]),
              _: 3
            }), __props.showRightPanel ? (_openBlock(), _createBlock(_component_vxe_split_pane, {
              key: 0,
              width: rightSplitPanelProps.panelWidth
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [_renderSlot(_ctx.$slots, "right-panel")])]),
              _: 3
            }, 8, ["width"])) : _createCommentVNode("", true)]),
            _: 3
          }, 16)]),
          _: 3
        })]),
        _: 3
      }, 16)])]);
    };
  }
};